import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { QRCodeSVG } from 'qrcode.react';
import Footer from "./partials/Footer";
import { saveAs } from 'file-saver';

function Necrologio() {
  const { id: annuncioId } = useParams();
  const qrCodeRef = useRef();
  const [annuncio, setAnnuncio] = useState(null);
  const [allegati, setAllegati] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [agenzia, setAgenzia] = useState(null);
  const [likes, setLikes] = useState(0);
  const [hasLiked, setHasLiked] = useState(false); 
  
  const MYURL = window.location.href;

  const getImageUrl = (annuncio) => {
    if (!annuncio || !annuncio.img) return "/necrologi/vuoto.jpg";
    return `https://app.ilnecrologio.info/necrologi/${annuncio.id_utente}/${annuncio.img}`;
  };

  const copyPageLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      alert('Link copiato!');
    } catch (err) {
      alert('Impossibile copiare il link.');
    }
  };

  const titoloPerCondivisione = annuncio ? `In ricordo di ${annuncio.nome} ${annuncio.cognome}` : "Necrologio";

  useEffect(() => {
    const fetchAnnuncio = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`/api/outNecrologio/${annuncioId}`);
        if (response.ok) {
          const data = await response.json();
          setAnnuncio(data[0]);
          setLikes(data[0].cuori || 0);
        } else {
          throw new Error("Errore nel recupero dell'annuncio.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAnnuncio();
  }, [annuncioId]);
  
  useEffect(() => {
    if (annuncio && annuncio.id_utente) { 
      fetch(`/api/agof/${annuncio.id_utente}`)
        .then(response => response.json())
        .then(data => setAgenzia(data));
    }
  }, [annuncio]); 

  useEffect(() => {
    const fetchAllegati = async () => { 
      try {
        const response = await fetch(`/api/outAllegati/${annuncioId}`);
        if (response.ok) {
          const data = await response.json();
          setAllegati(data || []);
        }
      } catch (err) { console.error(err); }
    };
    fetchAllegati();
  }, [annuncioId]);

  const handleLike = async () => {
    if (hasLiked) return;
    try {
      const response = await fetch(`/api/like/${annuncioId}`, { method: "POST" });
      if (response.ok) {
        setLikes((prevLikes) => prevLikes + 1);
        setHasLiked(true);
      }
    } catch (err) { console.error(err); }
  };

  const downloadQRCode = () => {
    if (!qrCodeRef.current) return;
    const svg = qrCodeRef.current.querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      canvas.width = 1000;
      canvas.height = 1000;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, 1000, 1000);
      ctx.drawImage(img, 0, 0, 1000, 1000);
      saveAs(canvas.toDataURL("image/png"), `QRCode_${annuncio.nome}.png`);
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  const handleDownloadImg = () => {
    const downloadLink = `https://app.ilnecrologio.info/necrologi/${annuncio.id_utente}/${annuncio.img}`;
    saveAs(downloadLink, annuncio.img);
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>{annuncio ? `In ricordo di ${annuncio.nome} ${annuncio.cognome}` : "ilNecrologio.info"}</title>
      </Helmet>
      
      <section className="main_content dashboard_part">
        {isLoading ? (
          <p className="text-center p-5">Caricamento in corso...</p>
        ) : error ? (
          <div className="alert alert-danger" role="alert">{error}</div>
        ) : annuncio ? ( 
          <React.Fragment key={annuncio._id}>
            {/* LOGO E TASTO INDIETRO */}
            <div className="row justify-content-center">
              <div className="col-md-8 col-sm-12 p-0 text-center">
                <div className="p_30">
                    <a href="https://www.ilnecrologio.info">
                      <img src="/img/ilNecrologio_info.svg" alt="Logo" style={{ width: "150px" }} />
                    </a>
                </div>
                <div className="d-flex justify-content-center align-items-center p_0">
                  <a href="#!" onClick={(e) => { e.preventDefault(); window.history.back(); }} className="btn btn-light">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="auto" viewBox="0 0 512 512">
                    <path fill="#B197FC" d="M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"/></svg>
                    {" "}Indietro
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-8 offset-md-2 col-sm-12 p-0">
              <div className="header_iner justify-content-center">
                {/* IMMAGINE DEFUNTO */}
                <div className="row justify-content-center">
                  <div className="col-md-8 col-sm-12 mt_50 mb_30">
                    <div className="white_box_tittle list_header">
                      <img
                        src={getImageUrl(annuncio)}
                        alt="Defunto"
                        onError={(e) => { e.target.src = "/necrologi/vuoto.jpg"; }}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>

                {/* DATI ANAGRAFICI */}
                <div className="serach_field-area text-center"> 
                  <h2 className="titoloPubblico mb_30">
                    {annuncio.nome} {annuncio.cognome}<hr />                    
                  </h2>
                  <h3 className="indirizzoPubblico" style={{fontWeight: '400'}}>
                    {annuncio.nato && (
                      <>Nata/o a {annuncio.natoA} il {new Date(annuncio.nato).toLocaleDateString("it-IT")}</>
                    )}
                    {annuncio.decesso && (
                      <><br /><br />Deceduta/o il {new Date(annuncio.decesso).toLocaleDateString("it-IT")} a {annuncio.mortoA}</>
                    )}                    
                    {annuncio.coniuge && <><br /><br />Coniuge: {annuncio.coniuge}</>}
                    <br /><br />{annuncio.cap} - {annuncio.comune} ({annuncio.prov}) - {annuncio.regione}
                    
                    <hr />
                    {/* ICONA TESTO */}
                    <svg xmlns="http://www.w3.org/2000/svg" height="60" width="auto" viewBox="0 0 640 640">
                      <path fill="#B197FC66" d="M560 128C573.2 128 580.7 143.1 572.8 153.6L544 192L544 368C544 447.5 479.5 512 400 512L288 512L241.7 558.3C231.3 568.7 215.2 570.7 202.6 563.1L105.5 504.9C88.5 494.7 90.5 469.4 108.9 462L224 416C87.8 375.1 71.5 233.8 86 159.7C89.6 141.9 109.3 135.4 125.3 144.2L384 288L384 208C384 163.8 419.8 128 464 128L560 128zM464 184C450.7 184 440 194.7 440 208C440 221.3 450.7 232 464 232C477.3 232 488 221.3 488 208C488 194.7 477.3 184 464 184zM246.5 54.4C258.9 40.7 279.8 45.5 289 61.5L345.4 159.8C339.6 174.2 336.2 189.9 336 206.3L202.1 132C212.2 100.4 229.1 73.6 246.5 54.4z"/></svg>
                    <br />{annuncio.testo}

                    {/* TASTO MI PIACE */}
                    <div className="like-container text-center mt-4">
                      <button className="btn btn-primary" onClick={handleLike} disabled={hasLiked}>
                        {hasLiked ? "Grazie ❤️" : "Sarai sempre nel mio cuore ❤️"}
                      </button>
                    </div>

                    {/* FUNERALE E CIMITERO */}
                    {annuncio.funerale && (
                      <>
                        <hr />
                        <svg xmlns="http://www.w3.org/2000/svg" height="60" width="auto" viewBox="0 0 640 512">
                        <path fill="#B197FC66" d="M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2L160 512l96 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 96 0 0-260.8c0-16.9-8.8-32.5-23.3-41.2L344 142.4 344 96l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4L0 464c0 26.5 21.5 48 48 48l80 0 0-238.4L24.9 330.3zM592 512c26.5 0 48-21.5 48-48l0-91.6c0-17.5-9.5-33.6-24.9-42.1L512 273.6 512 512l80 0z"/></svg>
                        <br />{annuncio.funerale}
                      </>
                    )}
                    {annuncio.cimitero && (
                      <>
                        <hr />
                        <svg xmlns="http://www.w3.org/2000/svg" height="60" width="auto" viewBox="0 0 384 512">
                        <path fill="#B197FC66" d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>
                        <br />{annuncio.cimitero}
                      </>
                    )}
                  </h3>
                </div>
              </div>              
            </div>
          </React.Fragment>
        ) : null} 
        
        {/* ALLEGATI */}
        {allegati.length > 0 && (
          <div className="col-lg-12 text-center mt-5">
              <h4>Partecipazioni & Ringraziamenti</h4>
              {allegati.map(allegato => (
                <div key={allegato._id} className="mb_30">
                    <img src={`/necrologi/${allegato.id_utente}/${allegato.img}`} className="img-fluid bordoChiaro" style={{maxWidth: '400px'}} alt="Allegato" />
                </div>
              ))}
          </div>
        )}

        {/* INFO AGENZIA E CONDIVISIONE */}
        <div className="col-md-8 offset-md-2 col-sm-12 p-4 text-center mt-5 bg-light rounded">
            {agenzia && ( 
            <div className="info-agenzia mb-4">
                {agenzia.logo && <img src={`/necrologi/${agenzia._id}/logo/${agenzia.logo}`} className="img-fluid mb-2" style={{maxWidth: '120px'}} alt="Logo Agenzia" />}
                <h3>{agenzia.ragSociale}</h3>
                <h4 style={{color: '#b19dc9', fontSize: '0.9rem'}}>
                    {agenzia.comune.toUpperCase()} ({agenzia.prov.toUpperCase()})<br /><br />
                    {agenzia.tel && <>Tel: {agenzia.tel}{agenzia.cell ? " - " : ""}</>}
                    {agenzia.cell && <>Cell: {agenzia.cell}</>}
                </h4>
            </div>
            )}

            <hr />
            <p><i>Condividi questo annuncio</i></p>
            <div className="text-center mb-3" ref={qrCodeRef}>
              <QRCodeSVG value={MYURL} size={192} fgColor="#b19dc9" />
            </div>
            <button className="btn btn-sm btn-primary mt-3 mb-4" onClick={downloadQRCode}>
                Scarica QR Code
            </button>
            
            <div className="share-buttons mb-5">
                <a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(titoloPerCondivisione + " " + MYURL)}`} 
                   target="_blank" rel="noreferrer" className="btn btn-sm btn-primary m-1" title="WhatsApp">
                   <i className="fab fa-whatsapp"></i>
                </a>
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(MYURL)}`} 
                   target="_blank" rel="noreferrer" className="btn btn-sm btn-primary m-1" title="Facebook">
                   <i className="ti-facebook"></i>
                </a>
                <a href={`https://www.addtoany.com/add_to/x?linkurl=${encodeURIComponent(MYURL)}&title=${encodeURIComponent(titoloPerCondivisione)}`} 
                   target="_blank" rel="noreferrer" className="btn btn-sm btn-primary m-1" title="X">
                   <i className="ti-twitter"></i>
                </a>
                <a href={`https://www.addtoany.com/add_to/telegram?linkurl=${encodeURIComponent(MYURL)}&title=${encodeURIComponent(titoloPerCondivisione)}`} 
                   target="_blank" rel="noreferrer" className="btn btn-sm btn-primary m-1" title="Telegram">
                   <i className="fab fa-telegram"></i>
                </a>
                <button onClick={handleDownloadImg} className="btn btn-sm btn-primary m-1" title="Scarica Foto">
                   <i className="ti-download"></i>
                </button>
                <button onClick={copyPageLink} className="btn btn-sm btn-primary m-1" title="Copia Link">
                   <i className="far fa-copy"></i>
                </button>
            </div>
            <div className="d-flex justify-content-center align-items-center p_0">
              <a href="#!" onClick={(e) => { e.preventDefault(); window.history.back(); }} className="btn btn-light">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="auto" viewBox="0 0 512 512">
                <path fill="#B197FC" d="M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"/></svg>
                {" "}Indietro
              </a>
            </div>
        </div>
        <Footer />
      </section>
    </HelmetProvider>
  );
}

export default Necrologio;